// extracted by mini-css-extract-plugin
export var numpadContainer = "_kl-1";
export var phoneButton = "_kl-0";